<template>
  <!-- 最外层 -->
  <div
    class="list_one"
    :key="item.id"
    :style="{
    padding:  paddingTop/2 + 'px ' + paddingLeft/2 + 'px',
    width:type === 'ordinary' ? 100 / col + '%' : '100%'
    }"
    data-comb-dom
    @click="sel"
    :data-col_num="$store.state.app.view_pattern == 'pc' ? col : col >= 2 ? 2 : 1"
    :class="$store.state.app.view_pattern == 'mb' && col == 1 ? 'absolutely' : ''"
    @mouseenter="module_isHover(true)"
    @mouseleave="module_isHover(false)"
  >
    <div class="basic_atlas_catalog_one_frame" :style="{
      ...box_shadow,
      ...getBackgroundStyle,
      '--seBgColor':seBgColor
      }">
      <!-- 图片 -->
      <div
        class="list_img_frame animationBox"
        ref="animationBox"
        :style="{paddingBottom:height}"
        @mouseenter="(e) => { templet.enter_animation(this.img_effects, e.target, this.$store.state.app.view_pattern) }"
        @mouseleave="(e) => { templet.leave_animation(this.img_effects, e.target) }"
      >
        <div
          class="list_img_back animationImg"
          :style="{
        backgroundImage:'url(' + item.lists[0].img_path + ')',
        backgroundSize:backgroundSize.radio_val === 'default' ? backgroundSize.default.backgroundSize : backgroundSize.custom.backgroundSize
      }"
          v-if="item.lists && item.lists.length > 0"
        ></div>
        <div class="num">
          <span>{{item.lists ? item.lists.length : 0}}</span>
          <i v-if="$store.state.app.view_pattern === 'pc'"></i>
        </div>
      </div>

      <!-- 内容 -->
      <div class="name">{{item.album_name}}</div>

      <div class="tooptipPart" v-if="$store.state.app.view_pattern === 'pc'" @click.stop>
        <my_hover_btn :tips="$t('widgets_basic_atlas_catalog_components_one_img_428')" btnIcon="el-icon-edit" @changeStyle="edit_one"></my_hover_btn>
        <my_hover_btn :tips="$t('widgets_basic_atlas_catalog_components_one_img_429')" btnIcon="el-icon-close" @changeStyle="del_one(item)"></my_hover_btn>
      </div>
    </div>

    <add_atlas v-if="isShow" @close="add_atlas_close" @submit_sure="submit_sure" :editId="item.id"></add_atlas>
  </div>
</template>

<script>
import i18n from '../../../language/index'

import add_atlas from "@/components/basic_addAtlas";
import { delete_atlas } from "@/api/app";
import {getBoxShadowStyle} from '@/utils/utils'
export default {
  name: "basic_atlas_catalog_one_img",
  data() {
    return {
      pc_look_isShow: false,
      select_atlas: null,
      isShow: false,
      isHover: false
    };
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    item: {
      type: Object,
      default: null
    },
    all_list: {
      type: Array,
      default: function() {
        return [];
      }
    },
    type: {
      type: String,
      default: "ordinary"
    },
    height: {
      type: String,
      default: "10%"
    },
    col: {
      type: Number,
      default: 7
    },
    backgroundSize: {
      type: Object,
      default: {}
    },
    paddingTop: {
      type: Number,
      default: 0
    },
    paddingLeft: {
      type: Number,
      default: 0
    },
    fromTag: { // 是否为全局搜索挂件
      type: String,
      default: ''
    }
  },
  methods: {
    module_isHover (val) {
      this.isHover = val
    },
    sel() {
      this.$store.commit("atlas_look/SET_is_Show", true);
      this.$store.commit("atlas_look/SET_now_item", this.item);
      this.$store.commit("atlas_look/SET_all_list", this.all_list);
    },
    close_look() {},
    edit_one() {
      this.isShow = true;
    },
    del_one(item) {
      this.$confirm(i18n.t('widgets_basic_atlas_catalog_components_one_img_430'), "", {
        confirmButtonText: i18n.t('view_public_topbar_24'),
        cancelButtonText: i18n.t('view_public_topbar_11'),
        center: true,
        // customClass: "del_dialog",
        appendToBody: true
      })
        .then(() => {
          this.delete_atlas(item);
        })
        .catch(() => {});
    },

    delete_atlas(item) {
      delete_atlas({ ids: item.id })
        .then(e => {
          if (e.code == 200) {
            this.$message.success({
              showClose: true,
              message: e.message ? e.message : i18n.t('widgets_basic_atlas_catalog_components_one_img_431')
            });
            this.$emit("edit_atlas_sure");
          } else {
            this.$message.error(e.message);
          }
        })
        .catch(res => {
          this.$message.error(res.message);
        });
    },
    submit_sure() {
      this.$emit("edit_atlas_sure");
    },
    add_atlas_close() {
      this.isShow = false;
    }
  },
  computed: {
    img_effects() {
      return this.module.data.img_effects;
    },
    pc_infor () {
      return this.module.data.pc_widgets_infor
    },
    listArr() {
      return this.module.data.listArr
    },
    getBackgroundStyle(){
      if (this.fromTag === 'search' && this.listArr.styleType === 'type2') {
        return {...this.$utils.getBackground(this.pc_infor.background)}
      }
    },
    seBgColor() {
      if (this.fromTag === 'search' && this.listArr.styleType === 'type2') {
        return this.pc_infor.background[this.pc_infor.background.radio_val].seColor
      }      
    },
    box_shadow(){ // 阴影设置 只有PC端才能有阴影 其他的不存在
      return this.$store.state.app.view_pattern === 'pc'&& (this.fromTag !== 'search'  || (this.fromTag === 'search' && this.listArr.styleType === 'type2') )
      ?(this.isHover ? getBoxShadowStyle(this.pc_infor.boxShadow, 'hover') :getBoxShadowStyle(this.pc_infor.boxShadow)):{}
    },
  },
  components: {
    add_atlas
  },
  created() {},
  mounted() {
    this.templet.initImageAnimation(
      this.img_effects,
      this.img_effects,
      this.$refs.animationBox,
      this.$store.state.app.view_pattern
    );
  }
};
</script>

<style scoped lang="scss">
.basic_atlas_catalog {
  .list_one {
    display: inline-block;
    vertical-align: top;
    position: relative;
    overflow: hidden;
    .basic_atlas_catalog_one_frame {
      -webkit-border-radius: 3px;
      -moz-border-radius: 3px;
      border-radius: 3px;
      height: 100%;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      background: #fff;
      /* -webkit-box-shadow: 0 0 22px rgba(0, 0, 0, 0.1);
      -moz-box-shadow: 0 0 22px rgba(0, 0, 0, 0.1);
      box-shadow: 0 0 22px rgba(0, 0, 0, 0.1); */
      padding: 5%;
      position: relative;
      cursor: pointer;
      .list_img_frame {
        position: relative;
        overflow: hidden;
        .list_img_back {
          width: 100%;
          height: 100%;
          position: absolute;
          background-position: center center;
          -webkit-transition: all ease 0.36s;
          -o-transition: all ease 0.36s;
          -moz-transition: all ease 0.36s;
          transition: all ease 0.36s;
          background-repeat: no-repeat;
        }
        .num {
          position: absolute;
          right: 6px;
          bottom: 6px;
          font-size: 12px;
          color: #fff;
          background-color: rgba(0, 0, 0, 0.5);
          height: 24px;
          line-height: 24px;
          padding: 0 5px;
          i {
            display: inline-block;
            width: 14px;
            height: 12px;
            background: #fff;
            margin-left: 4px;
            margin-top: 6px;
            vertical-align: top;
            background: url("/static/image/backimg1.png") -23px -306px;
          }
        }
      }
      .name {
        margin-top: 15px;
        font-size: 16px;
        color: #333;
        line-height: 24px;
        max-height: 50px;
        overflow: hidden;
        -o-text-overflow: ellipsis;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        white-space: pre-wrap;
      }
    }
    .basic_atlas_catalog_one_frame:hover{
      background-color:var(--seBgColor) !important;
    }
    .tooptipPart {
      right: 0;
      bottom: 0;
      top: auto;
      display: none;
      z-index: 999;
    }
  }

  .list_one:hover .list_img_back {
    // transform: scale(1.05);
  }
  .list_one:hover .tooptipPart {
    display: block;
  }
  .list_one:hover .name{
    color: var(--theme_color);
  }
}
.mb_pattern {
  .basic_atlas_catalog {
    .list_one {
      width: 50% !important;
      padding:5px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_atlas_catalog/components/one_img.vue